import { parseToKebabCase } from '../../helpers/parsers';
import * as csg from './csg';
import * as gd from './gd';
import * as gsma from './gsma';
import * as netlync from './netlync';

export function getTheme(theme: string): any {
  switch (theme) {
    case 'gsma':
      return gsma;
    case 'csg':
      return csg;
    case 'gd':
      return gd;
    case 'netlync':
      return netlync;
    default:
      return netlync;
  }
}

export function loadCssTheme(theme: string) {
  const { styles, fonts } = getTheme(theme);
  loadStyles(styles);
  loadFonts(fonts);
}

// HELPERS
function loadStyles(styles: any) {
  // Remove any previously-injected theme styles so callers can swap themes at runtime.
  const existing = document.getElementById('custom-styles');
  if (existing) existing.remove();

  // Create a style element
  const style = document.createElement('style');
  style.id = 'custom-styles';
  let cssVariables = ':root {\n';

  // Convert camelCase to kebab-case and add the styles to the root
  for (const [key, value] of Object.entries(styles)) {
    cssVariables += `--${parseToKebabCase(key)}: ${value};\n`;
  }

  cssVariables += '}';

  // Add the CSS to the style element
  style.innerHTML = cssVariables;

  // Append the style element to the head of the document
  document.head.appendChild(style);
}

function loadFonts(fonts: string[]) {
  const fragment = document.createDocumentFragment();

  fonts.forEach((url: string) => {
    // Create a unique ID for each font URL to prevent duplicates
    const id = `font-import-${url.replace(/=/g, '')}`;

    // Check if the font with the specific URL has already been injected
    if (document.getElementById(id)) return;

    // Create a link element
    const link = document.createElement('link');
    link.id = id; // Set a unique ID based on the URL
    link.rel = 'stylesheet'; // Specify it's a stylesheet link
    link.href = url; // Set the URL of the stylesheet

    // Append the link element to the fragment
    fragment.appendChild(link);
  });

  // Append the fragment to the document head
  if (fragment.childNodes.length > 0) {
    document.head.appendChild(fragment);
  }
}
